module.exports = __webpack_public_path__ + "media/images/registrations/product_version/bg-06-7eccbf44517614d42fda05a4efb3b724.png";